import * as coreApi from "./exports"; // for namespacing

export default coreApi;

export { querykeys } from "./querykeys";
